/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc directive
 * @name header
 * @restrict E
 */
angular.module('aviApp').directive('header', [
'$state', '$filter', '$transitions',
function($state, $filter, $transitions) {
    function headerLink(scope) {
        const setVisibility = () => {
            const stateIncludesFilter = $filter('currentStateIncludes');
            const hasAlerts = stateIncludesFilter('alerts');
            const hasBgpPeers = stateIncludesFilter('bgp-peers');
            const hasEvents = stateIncludesFilter('events');
            const hasLogs = stateIncludesFilter('logs');
            const isInsights = stateIncludesFilter('hs-insights');
            const stateContext = $filter('stateContext')($state.$current);

            scope.hasBgpPeers = hasBgpPeers;
            scope.hideMetricValueTypeSelector = hasLogs || hasEvents || hasAlerts || isInsights || hasBgpPeers;
            scope.hideTimeframeSelector = isInsights || hasBgpPeers;

            function showAs(context) {
                return stateContext === context || $state.includes(`**.${context}.**`);
            }

            scope.showAsSE = showAs('serviceengine-detail');
            scope.showAsVS = showAs('virtualservice-detail');
        };

        const destroyTransitionListener = $transitions.onSuccess({}, () => setVisibility());

        scope.$on('$destroy', () => destroyTransitionListener());

        setVisibility();
    }

    return {
        restrict: 'E',
        scope: true,
        link: headerLink,
        template: require('../../views/infrastructure/header.partial.html'),
    };
}]);
